module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/line.be150817.gif";